import {Injectable} from '@angular/core';
import {handleResult} from "@share/utils/handle-result";
import {Result} from "@domain/common/http/result";
import {FormulaireHttpService} from "@services/admin/parametre/formulaire/formulaire-http.service";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {finalize} from "rxjs/operators";
import {ParamFacture} from "@domain/admin/parametre/formulaire/param-facture";

/**
 * Service du formulaire Facture
 *
 * @author Lionel Gimenez
 * @date 25/09/2025
 */
@Injectable()
export class FormulaireFactureService {
    /** Indicateur pour savoir si on est en cours de sauvegarde */
    isSaving: boolean = false;

    /** Paramètres Formulaire Facture */
    paramFacture: ParamFacture;

    /**
     * Constructeur
     */
    constructor(
        private formulaireHttpService: FormulaireHttpService,
        private translateService: TranslateService,
        private toastrService: ToastrService
    ) {
    }

    /**
     * Charge les données
     */
    load(): void {
        this.formulaireHttpService.getParamFacture()
            .pipe(handleResult(this.translateService, this.toastrService, null, 'global.errors.generic'))
            .subscribe((result: Result) => {
                this.paramFacture = result.data.param;
            });
    }

    /**
     * Sauvegarde les données
     */
    save(): void {
        this.isSaving = true;

        this.formulaireHttpService.saveParamFacture(this.paramFacture)
            .pipe(
                handleResult(this.translateService, this.toastrService),
                finalize(() => this.isSaving = false))
            .subscribe((result: Result) => {
                //Refresh
                this.load();
            });
    }
}
